import React from "react";
import { connect } from "react-redux";
import { Box, Divider, Flex, Text } from "@chakra-ui/react";
import { GrMap } from "react-icons/gr";
import { IoPersonCircleOutline, IoCheckboxOutline } from "react-icons/io5";
import { HiOutlineMail } from "react-icons/hi";
//import { RiText } from "react-icons/ri";
import { FiPhone, FiLink2 } from "react-icons/fi";
import { BiParagraph } from "react-icons/bi";
import { TiSortNumericallyOutline } from "react-icons/ti";
import { CgChevronDownR } from "react-icons/cg";
import { ImStarEmpty } from "react-icons/im";
import Draggable from "./Draggable";
import DragIcon from "./Icons/Drag";
import PersonIcon from "./Icons/Person";
import TextFieldIcon from "./Icons/TexField";
import NumberIcon from "./Icons/Number";
import DropDownIcon from "./Icons/DropDown";
import ParagraphIcon from "./Icons/Paragraph";
import CheckBoxIcon from "./Icons/CheckBox";
import UrlIcon from "./Icons/Url";
import RatingIcon from "./Icons/Rating";
import AddressIcon from "./Icons/Address";
import EmailIcon from "./Icons/Email";
import PhoneIcon from "./Icons/Phone";

const FIELD_TYPES = {
  firstName: "firstName",
  lastName: "lastName",
  email: "email",
  phone: "phone",
  address: "address",
  textField: "textField",
  url: "url",
  paragraph: "paragraph",
  number: "number",
  dropDown: "dropDown",
  checkBox: "checkBox",
  rating: "rating",
};

const DragFieldSidebar = ({ dropped }) => {
  const isFieldDropped = (type) => {
    return !!dropped.filter((field) => field.type == type).length;
  };
  return (
    <Box
      bg="#fff"
      borderRadius="sm"
      m="16px"
      p="20px"
      minH="622px"
      minW="421px"
    >
      <Text fontSize="16px" mb="16px" fontWeight="600" color="#12344D">
        Field elements
      </Text>
      <Divider />
      <Box w="380px" h="168px">
        <Text
          fontSize="14px"
          mb="12px"
          mt="16px"
          fontWeight="600"
          color="#475867"
        >
          Contact fields
        </Text>
        <Box w="380px" h="136px">
          <Flex>
            <Draggable
              type={{ type: FIELD_TYPES.firstName }}
              isDisabled={isFieldDropped(FIELD_TYPES.firstName)}
              isEven={false}
            >
              <DragIcon />
              <PersonIcon />
              <Text fontSize="14px" ml="2">
                First name
              </Text>
            </Draggable>
            <Draggable
              type={{ type: FIELD_TYPES.lastName }}
              isDisabled={isFieldDropped(FIELD_TYPES.lastName)}
              isEven={true}
            >
              <DragIcon />
              <PersonIcon className="ml-1" />
              <Text fontSize="14px" ml="2">
                Last name
              </Text>
            </Draggable>
          </Flex>
          <Flex mt="8px">
            <Draggable
              type={{ type: FIELD_TYPES.email }}
              isDisabled={isFieldDropped(FIELD_TYPES.email)}
              isEven={false}
            >
              <DragIcon />
              <EmailIcon />
              <Text fontSize="14px" ml="2">
                Email
              </Text>
            </Draggable>
            <Draggable
              type={{ type: FIELD_TYPES.phone }}
              isDisabled={isFieldDropped(FIELD_TYPES.phone)}
              isEven={true}
            >
              <DragIcon />
              <PhoneIcon />
              <Text fontSize="14px" ml="2">
                Phone number
              </Text>
            </Draggable>
          </Flex>
          <Flex mt="8px">
            <Draggable
              type={{ type: FIELD_TYPES.address }}
              isDisabled={isFieldDropped(FIELD_TYPES.address)}
              isEven={false}
            >
              <DragIcon />
              <AddressIcon />
              <Text fontSize="14px" ml="2">
                Address
              </Text>
            </Draggable>
          </Flex>
        </Box>
      </Box>
      <Box mt="32px" w="380px" h="216px">
        <Text
          fontSize="14px"
          mb="12px"
          fontWeight="600"
          color="#475867"
          w="105px"
          h="20px"
        >
          Standard fields
        </Text>
        <Box>
          <Flex mt="8px">
            <Draggable type={{ type: FIELD_TYPES.textField }} isEven={false}>
              <DragIcon />
              <TextFieldIcon />
              <Text fontSize="14px" ml="2">
                Text field
              </Text>
            </Draggable>
            <Draggable type={{ type: FIELD_TYPES.paragraph }} isEven={true}>
              <DragIcon />
              <ParagraphIcon />
              <Text fontSize="14px" ml="2">
                Paragraph
              </Text>
            </Draggable>
          </Flex>
          <Flex mt="8px">
            <Draggable type={{ type: FIELD_TYPES.number }} isEven={false}>
              <DragIcon />
              <NumberIcon />
              <Text fontSize="14px" ml="2">
                Number
              </Text>
            </Draggable>
            <Draggable type={{ type: FIELD_TYPES.checkBox }} isEven={true}>
              <DragIcon />
              <CheckBoxIcon />
              <Text fontSize="14px" ml="2">
                Checkboxes
              </Text>
            </Draggable>
          </Flex>
          <Flex mt="8px">
            <Draggable type={{ type: FIELD_TYPES.dropDown }} isEven={false}>
              <DragIcon />
              <DropDownIcon />
              <Text fontSize="14px" ml="2">
                Dropdown
              </Text>
            </Draggable>
            <Draggable type={{ type: FIELD_TYPES.url }} isEven={true}>
              <DragIcon />
              <UrlIcon />
              <Text fontSize="14px" ml="2">
                URL
              </Text>
            </Draggable>
          </Flex>
          <Flex mt="8px">
            <Draggable type={{ type: FIELD_TYPES.rating }} isEven={false}>
              <DragIcon />
              <RatingIcon />
              <Text fontSize="14px" ml="2">
                Rating
              </Text>
            </Draggable>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    dropped: state.form.dropped,
  };
};

export default connect(mapStateToProps, null)(DragFieldSidebar);
